// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610082105/js/" + chunkId + "." + {"44":"d7744da7","225":"d1d91df3","481":"ddc6573a","486":"d0c3b09a","770":"e70b190b"}[chunkId] + ".0.07163846162804521.chunk.js";
};